/* eslint-disable no-console */
import {useQueryClient} from '@tanstack/react-query';
import {DenialLetterParams} from 'domain/usecases';
import {useCallback} from 'react';
import {useGetDenialLetterQuery} from '../queries/useGetDenialLetterQuery';

export const useDenialLetterHandler = (params: DenialLetterParams) => {
	const {
		data: denialLetterData,
		refetch: fetchDenialLetter,
		isFetching: isFetchingDenialLetter,
	} = useGetDenialLetterQuery(params);
	const queryClient = useQueryClient();

	const triggerDownload = (blob: Blob) => {
		const url = URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.download = `termo-de-indeferimento-${params.nu_controle}.pdf`;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	};

	const downloadDenialLetter = useCallback(async () => {
		try {
			if (denialLetterData) {
				triggerDownload(denialLetterData as Blob);
				return;
			}

			const {data} = await fetchDenialLetter();
			if (!data) throw new Error('Arquivo não retornado.');
			triggerDownload(data);
		} catch (error) {
			console.error('Erro ao gerar carta de indeferimento:', error);
			throw new Error('Falha ao gerar a carta de indeferimento.');
		}
	}, [fetchDenialLetter, params, queryClient]);

	return {
		isFetchingDenialLetter,
		downloadDenialLetter,
	};
};
